import React, { useState } from "react";
import MUIDataTable from "mui-datatables";
import CustomToolbarSelect from "./CustomToolbarSelect";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const TableComponent = ({ title, columns, data, filter, download ,selectableRowsHideCheckboxes=true ,expandableRows = false, onRowsSelect=()=>{}, rowsPerPage:defaultRowsPerPage=10, search = true, onSearchChange, elevation = 4, pagination = true, rowsSelected, selectableRows = "multiple", serverSide = false}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);

  const options = {
    page: page,
    rowsPerPage: rowsPerPage,
    onChangePage: (currentPage) => {
      setPage(currentPage);
    },
    onChangeRowsPerPage: (numberOfRows) => {
      setRowsPerPage(numberOfRows);
    },
    rowsSelected: rowsSelected,
    filterType: 'dropdown',
    download: download,
    filter: filter,
    print: false,
    viewColumns: false,
    search: search,
    elevation: elevation,
    pagination: pagination,
    serverSide: serverSide, 
    ...(onSearchChange && {
      onSearchChange: (searchText) => {
        onSearchChange(searchText?.trim() ?? "");
      },
    }),
    selectableRowsHideCheckboxes: selectableRowsHideCheckboxes,
    selectableRows: selectableRows,
    expandableRows: expandableRows,
    onRowSelectionChange:onRowsSelect,
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <CustomToolbarSelect selectedRows={selectedRows} displayData={displayData} setSelectedRows={setSelectedRows} />
    ),
    renderExpandableRow: (rowData, rowMeta) => {
      console.log(rowData, rowMeta);
      return (
        <React.Fragment>
          <tr>
            <td colSpan={6}>
              <TableContainer component={Paper}>
                <Table style={{ minWidth: "650" }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Dessert (100g serving)</TableCell>
                      <TableCell align="right">Calories</TableCell>
                      <TableCell align="right">Fat&nbsp;(g)</TableCell>
                      <TableCell align="right">Carbs&nbsp;(g)</TableCell>
                      <TableCell align="right">Calories</TableCell>
                      <TableCell align="right">Fat&nbsp;(g)</TableCell>
                      <TableCell align="right">Calories</TableCell>
                      <TableCell align="right">Fat&nbsp;(g)</TableCell>
                      <TableCell align="right">Protein&nbsp;(g)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  </TableBody>
                </Table>
              </TableContainer>
            </td>
          </tr>
        </React.Fragment>
      );
    },
     rowsPerPageOptions: [10, 25, 50, 100] 
  };

  return (
      <MUIDataTable
        data={data}
        columns={columns}
        options={options}
      />
  )
}

export default TableComponent;